import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { Platform } from 'react-native';
import type { Database } from './database.types';
import { APP_MODE, mode } from '@/lib/config/app-mode';
import { createWebSecureStorage } from './web-secure-storage';
import { ExpoSecureStoreAdapter } from './auth-storage';

// Environment variables - set these in your .env or Expo config
const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY || '';

/**
 * @deprecated Use mode.useRealAPI from '@/lib/config/app-mode' instead
 * Kept for backwards compatibility during migration
 */
export const isSupabaseConfigured = (): boolean => {
  return mode.useRealAPI && Boolean(supabaseUrl && supabaseAnonKey);
};

// Auth session storage per platform: native → expo-secure-store (Keychain/
// Keystore); web → AES-GCM-encrypted localStorage (encryption at rest, gap G13).
// createWebSecureStorage() returns undefined when the browser can't support
// encryption, so supabase-js keeps its default (plain localStorage) rather than
// breaking sign-in — never worse than before.
const authStorage = Platform.OS === 'web' ? createWebSecureStorage() : ExpoSecureStoreAdapter;

// Create Supabase client only if backend is enabled (demo or production mode)
// In mock mode, create a placeholder client that won't be used
export const supabase: SupabaseClient<Database> = mode.useRealAPI && supabaseUrl && supabaseAnonKey
  ? createClient<Database>(supabaseUrl, supabaseAnonKey, {
      auth: {
        storage: authStorage,
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: Platform.OS === 'web',
      },
    })
  : createClient<Database>('https://placeholder.supabase.co', 'placeholder-key', {
      auth: {
        storage: authStorage,
        autoRefreshToken: false,
        persistSession: false,
      },
    });
